import ResourceService from './resource.service'

class NationalityService extends ResourceService {
  static get resource() {
    return 'countries'
  }
}

export default NationalityService
